module.exports = __webpack_public_path__ + "static/img/movement-home-default.e118d66.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/doom-yoga/movement-home-default.png
// module id = SMgN
// module chunks = 0